import React from 'react';
import { Radio } from '@ui';
import { RULE_ENFORCEMENT_BLOCK, RULE_ENFORCEMENT_GUIDANCE } from '../types';
/**
 * Explicit choice between guidance and a hard block (IP-16573).
 * The assistant never infers a hard block from the rule's wording.
 */
export default function RuleEnforcementChoice({ value, onChange, t }) {
    return (React.createElement("div", { className: "tkb-rule-form__field", "data-testid": "rule-enforcement" },
        React.createElement(Radio, { name: "tkb-rule-enforcement", label: t('rules.form.enforcement_label'), value: value, onChange: onChange, options: [
                {
                    value: RULE_ENFORCEMENT_GUIDANCE,
                    label: t('rules.form.enforcement_guidance'),
                    description: t('rules.form.enforcement_guidance_hint')
                },
                {
                    value: RULE_ENFORCEMENT_BLOCK,
                    label: t('rules.form.enforcement_block'),
                    description: t('rules.form.enforcement_block_hint')
                }
            ] })));
}
